<template>
  <div class="justify-content-md-center" v-if="!loaded">
    <loading-spinner></loading-spinner>
  </div>
  <div v-else>
    <div class="row">
      <div class="col">
        <div class="tags-wrapper">
          <template v-for="(integrations, integrationType) in chosen_integrations">
            <div class="integration-tag" v-for="(count, type_id) in integrations" v-if="count > 0">
              <img
                class="img-fluid img-logo"
                :src="
                  findById(integrationType == 'order_channel_types' ? order_channel_types : carrier_types, type_id)
                    .list_logo
                "
              />
              <span class="pl-2">
                {{
                  findById(integrationType == 'order_channel_types' ? order_channel_types : carrier_types, type_id).name
                }}
              </span>
              <div class="badge badge-primary ml-3">{{ count }}</div>
              <span class="pl-3" @click="subtract(chosen_integrations[integrationType], { id: type_id })" role="button"
                >&times;</span
              >
            </div>
          </template>
        </div>
        <input
          class="form-control mb-3"
          v-model="integration_query"
          placeholder="Search for order channels or carriers"
        />
        <template v-for="(list, filteredType) in filtered_types">
          <div class="row mb-2" v-for="t in list">
            <div class="col-md-8">
              <div class="row">
                <div class="col-md-2 text-center"><img class="img-fluid img-logo" :src="t.list_logo" /></div>
                <div class="col">
                  <span>{{ t.name }}</span>
                </div>
              </div>
            </div>
            <div class="col text-right">
              <div class="btn-group">
                <button
                  class="btn btn-sm btn-primary"
                  @click="
                    add(chosen_integrations[filteredType], t);
                    integration_query = '';
                  "
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  props: {
    value: {
      type: Array
    }
  },
  data: function () {
    return {
      carrier_types: null,
      chosen_carrier_types: {},
      order_channel_types: null,
      chosen_order_channel_types: {},
      carrier_query: '',
      order_channel_query: '',
      integration_query: '',
      chosen_integrations: {
        carrier_types: {},
        order_channel_types: {}
      },

      loaded: false
    };
  },
  mounted: async function () {
    await Api.findAllPages('carrier_types').then(({ data }) => {
      this.carrier_types = data;
    });
    await Api.findAllPages('order_channel_types').then(({ data }) => {
      this.order_channel_types = data;
    });

    this.loaded = true;

    this.restoreSelection();
  },
  methods: {
    restoreSelection() {
      this.chosen_order_channel_types = {};
      this.chosen_carrier_types = {};

      _.each(this.value, (line) => {
        if (line.key == 'carrier_integration') {
          this.add(this.chosen_integrations['carrier_types'], {
            id: line.model_id
          });
        }

        if (line.key == 'order_channel_integration') {
          this.add(this.chosen_integrations['order_channel_types'], {
            id: line.model_id
          });
        }
      });
    },
    findById(collection, id) {
      return _.find(collection, (e) => e.id == id);
    },
    add(collection, object) {
      let c = collection[object.id] || 0;
      this.$set(collection, object.id, c + 1);
    },
    subtract(collection, object) {
      let c = collection[object.id] || 0;
      this.$set(collection, object.id, c - 1);
    },
    toggle(collection, object) {
      if (collection.includes(object)) {
        collection.splice(collection.indexOf(object), 1);
      } else {
        collection.push(object);
      }
    }
  },
  computed: {
    conditions_met() {
      return true;
    },
    filtered_carrier_types() {
      if (this.integration_query == '') {
        return [];
      }

      return _.filter(
        this.carrier_types,
        (t) => t.name.toLowerCase().indexOf(this.integration_query.toLowerCase()) > -1
      );
    },
    filtered_order_channel_types() {
      if (this.integration_query == '') {
        return [];
      }

      return _.filter(
        this.order_channel_types,
        (t) => t.name.toLowerCase().indexOf(this.integration_query.toLowerCase()) > -1
      );
    },
    filtered_types() {
      return {
        order_channel_types: this.filtered_order_channel_types,
        carrier_types: this.filtered_carrier_types
      };
    },

    quote_lines() {
      let lines = [];

      //  Split count into n lines
      _.each(this.chosen_integrations['carrier_types'], (count, ct) => {
        _.times(count, (i) => {
          lines.push({
            unit_price: 0,
            quantity: 1,
            model_id: ct,
            model_type: 'Global::CarrierType',
            key: 'carrier_integration',
            description: `${this.findById(this.carrier_types, ct).name} integration`
          });
        });
      });
      _.each(this.chosen_integrations['order_channel_types'], (count, ct) => {
        _.times(count, (i) => {
          lines.push({
            unit_price: 0,
            quantity: 1,
            model_id: ct,
            model_type: 'Global::OrderChannelType',
            key: 'order_channel_integration',
            description: `${this.findById(this.order_channel_types, ct).name} integration`
          });
        });
      });

      return lines;
    }
  },
  watch: {
    quote_lines() {
      this.$emit('input', this.quote_lines);
    }
  }
};
</script>

<style lang="css" scoped>
.slider-wrapper >>> .slider-pagination-bullet-active {
  background-color: black;
  background-color: var(--primary);
}
.slider-wrapper >>> .slider-pagination-bullets {
  bottom: -5px;
}
.logo {
  height: 80px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.carrier-slide-item {
  font-size: 0.9rem;
  color: #343a40;
}

.img-logo {
  max-height: 30px;
}

.tags-wrapper {
  margin-bottom: 40px;
}

.integration-tag {
  padding: 5px 15px;
  margin: 10px;
  display: inline-block;
  box-shadow: 1px 0 15px 0 #8e8e8e61;
  border-radius: 23px;
}
</style>
